
import React, { useState } from 'react';
import { Button, Modal, Select, Space, Table, Tag } from 'antd';
import { DropDownApi } from '../../../Services/LocomotiveServices';
import { useEffect } from 'react';
const EnterByTaskModal = ({ showModal, handleOk, handleCancel, setData ,selectedValues ,setSelectedValues }) => {
    const { Option } = Select;
    const [options, setOptions] = useState([]);
    const [selectedValue, setSelectedValue] = useState(null);
    // const [selectedValues, setSelectedValues] = useState({});
    const updatedSetData = setData.map((item, index) => ({ ...item, key: index }));

    const fetchData = async () => {
        try {
            const response = await DropDownApi();
            setOptions(response?.data);
             
        } catch (error) {
            console.error('Error in component:', error);
        }
    };
    const contractormap = (data) => {
        if(data) {
            let {
                firstName,
                lastName,
                Company
            } = data;
    
            let output = '';
    
            if (Company)
                output = Company;
    
            if (Company && firstName && lastName)
                output = output + "-"
    
            if (firstName && lastName)
                output = `${output} ${firstName} ${lastName[0]}.`
    
            return output;
        }

        return ''
   
    };
    const columns = [
        {
            title: 'Category',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => {
                return <p>{record?.EquipWOTaskDD?.EquipWOSubCategory?.EquipWOCategory?.Category}</p>;
            },
        },
        {
            title: 'Sub Category	',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => {
                return <p>{record?.EquipWOTaskDD?.EquipWOSubCategory?.SubCategory}</p>;
            },
        },
        {
            title: 'Task',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => {
                return <p>{record?.EquipWOTaskDD?.Task}</p>;
            },
        },
        {
            title: 'Position',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => {
                return <p>{record?.Position || 'N/A'}</p>;
            },
        },

        {
            title: 'Assigned To	',
            dataIndex: 'name',
            key: 'name',
            // render: (text, record) => {
            //     return (
            //         <p>

            //             {record?.AssignedTo?.firstName && record?.AssignedTo?.lastName
            //                 ? `${record.AssignedTo.firstName} ${record.AssignedTo.lastName}`
            //                 : record?.AssignedtoContractor?.firstName && record?.AssignedtoContractor?.lastName  // Fix the typo here
            //                     ? `${record?.AssignedtoContractor?.firstName} ${record?.AssignedtoContractor?.lastName}`
            //                     : 'N/A'}
            //         </p>
            //     );
            // },
            render: (text, record) => {
                return <p>
                    
                    {record?.AssignedTo?.firstName && record?.AssignedTo?.lastName
                        ? `${record.AssignedTo.firstName} ${record.AssignedTo.lastName}`
                        : record?.AssignedtoContractor 
                            ? `${contractormap(record?.AssignedtoContractor) }`
                            : 'N/A'}
                </p>;
            },
        },
        {
            title: 'Status',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => {
                return <p>{record?.Status}</p>;
            },
        },
        // {
        //     title: 'Deleted By',
        //     dataIndex: 'name',
        //     key: 'name',
        //     render: (text, record) => {
        //         return <p>{record?.DeletedBy?.firstName + " " + record?.DeletedBy?.lastName}</p>;
        //     },
        // },
        {
            title: 'Notes',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => {
                return <p>{record?.Notes || 'N/A'}</p>;
            },
        },
        {
            title: 'Cause Code',
            dataIndex: 'dropdownColumn',
            key: 'dropdownColumn',
            render: (text, record) => (
                <Select
                    style={{ width: '165px' }}
                    value={selectedValues[record.key]}
                    onChange={(value) => handleSelectChange(record.key, value)}
                >
                    {options && options?.length > 0 ? (
                        options?.map((option) => (
                            <Select.Option key={option.id} value={option.CauseCode}>
                                {option.CauseName}
                            </Select.Option>
                        ))
                    ) : (
                        <Select.Option value={undefined} disabled>
                            Select any option
                        </Select.Option>
                    )}
                </Select>
            ),
        },
        // {
        //     title: 'Cause Code',
        //     dataIndex: 'dropdownColumn',
        //     key: 'dropdownColumn',
        //     render: (text, record) => (
        //         <Select
        //         style={{ width: '165px' }}
        //         value={selectedValue}
        //         onChange={(value) => setSelectedValue(value)}
        //       >
        //         {options && options?.length > 0 ? (
        //           options?.map(option => (
        //             <Select.Option key={option.id} value={option.CauseCode}>
        //               {option.CauseName}
        //             </Select.Option>
        //           ))
        //         ) : (
        //           <Select.Option value={undefined} disabled>
        //             Select any option
        //           </Select.Option>
        //         )}
        //       </Select>
        //     ),
        // },


    ];
    const handleSelectChange = (key, value) => {
         
         

        setSelectedValues((prevSelectedValues) => ({
            ...prevSelectedValues,
            [key]: value,
        }));
    };
    useEffect(() => {

        fetchData();


    }, []);
    return (
        <>

            <Modal className='modalWidth'
                title={<span style={{ color: '#2963ad', fontSize: '20px', fontWeight: '800', background: 'white' }}>Enter By Task</span>}
                open={showModal}
                okText="Submit"

                onOk={handleOk}
                onCancel={handleCancel}
            >
                <Table columns={columns} dataSource={updatedSetData} rowKey="key" />
            </Modal>
        </>
    );
};
export default EnterByTaskModal;